
export default function ProdunitHead() {
  return (
    <>
    <section className="detailserv-head header-gap"> 
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <span className="sub-tittle">Shaping Ideas into Reality</span>
                    <h1 className="heading">Our Production Unit</h1>
                    <p>Where craftsmanship meets technology to create timeless, functional, and flawless interiors. Every product is built with precision, passion, and an unwavering commitment to quality that defines the Saysha standard.</p>
                </div>
    
            </div>
        </div>

        <img src="/image/production-banner.webp" loading="lazy" className="img-responsive" alt="production"/>
    </section>  
    </>
  )
}
